module.exports = __webpack_public_path__ + "files/f1d0c5c5b434a0538c11692427edb3ea.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/organization.png
// module id = 585
// module chunks = 60